import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SharedInfoService {
  private infoMessage = new Subject<string>();

  message$ = this.infoMessage.asObservable();

  sendMessage(mensaje: string) {
    this.infoMessage.next(mensaje);
  }
}
